<template>
	<div id="footer" class="container-fluid">
		<div class="container footer-container">
		<!-- 	<div class="logo">
				<img src="@/assets/img/logo_white.png" alt="logo图">
			</div> -->
			<div class="footer-menu hidden-xs">
				<!-- 导航内容 -->
				<ul class="header-nav-wrapper">
					<li v-for="(item,index) in navList" :key="index" @click="navClick(index,item.name)"
						:style="{'text-align':item.children.length>0?'left':'center'}">
						<router-link :to="item.path">
							{{item.name}}
						</router-link>
						<dl v-if="item.children.length>0">
							<dt v-for="(i,n) in item.children" :key="n" @click="scrollTop()">
								<router-link :to="i.path" class="oneLine">{{i.name}}</router-link>
							</dt>
						</dl>
					</li>
				</ul>
			</div>
      <div class="text-center">主体备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index">鄂ICP备2021006349号-1</a> Copyright 2021  家谷网络有限公司  corporation，All Rights Reserverd</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "Footer",
		data() {
			return {
				navList: [{
						name: "首页",
				    en:"home",
						path: "/",
						children: []
					},
					{
						name: "宗亲文化",
				    en:"Culture",
						path: "/Culture", ///software
						children: []
					},
					{
						name: "云平台",
				    en:"Cloud",
						path: "/Cloud",
						children: [
							// {
							// 	name: "生命大数据平台",
							// 	path: "/BigLife",
							// 	children: [{
							// 			name: "真实世界研究支持",
							// 			path: "/BigLife/World"
							// 		},
							// 		{
							// 			name: "医药市场数据支持 ",
							// 			path: "/BigLife/Medicine"
							// 		},
							// 		{
							// 			name: "保险业务支持 ",
							// 			path: "/BigLife/Insurance"
							// 		}
							// 	]
							// },
						]
					},
					{
						name: "家谷动态",
				    en:"dynamic",
						path: "/dynamic",
						children: []
					},
					{
						name: "关于我们",
				    en:"About",
						path: "/About",
						children: []
					},
				  {
				  	name: "招贤纳士",
				    en:"recruit",
				  	path: "/recruit",
				  	children: []
				  },
				  {
				  	name: "招商谷",
				    en:"attract",
				  	path: "/attract",
				  	children: []
				  }
				]
			};
		},
		methods:{
			navClick(index, name) {
				this.$parent.$children[0].navIndex = index;
				if(index == 0){
					this.scrollTop()
				}
			},
			scrollTop(){
				// (function smoothscroll() {
				// 	var currentScroll =
				// 		document.documentElement.scrollTop || document.body.scrollTop;
				// 	if (currentScroll > 0) {
				// 		window.requestAnimationFrame(smoothscroll);
				// 		window.scrollTo(0,0);
				// 	}
				// })();
			}
		}
	};
</script>
<style scoped>
	#footer {
		width: 100%;
		overflow: hidden;
		text-align: center;
    background-image: url("../assets/img/footer-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-attachment: scroll;
    background-position: center center;
	}
	.footer-container{
		padding: 60px 20px 30px;
		display: flex;
    flex-direction: column;
	}
	.logo img{
		width: 220px;
		height: 75px;
		margin: 0 auto;
	}
	@media (max-width:767px) {
		.footer-container{
			padding: 20px;
			align-items: center;
			justify-content: center;
		}
		.logo img{
			width: 150px;
			height: 55px;
			margin: 0 auto;
		}
	}
	.footer-menu{
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 30px;
	}
	/* 导航栏 导航容器 */
	.header-nav-wrapper {
		width: 100%;
		line-height: 50px;
		display: flex;
	}
	/* 导航栏 每个导航 */
	.header-nav-wrapper>li {
		flex: 1;
		font-size: 1.5em;
	}
	.header-nav-wrapper>li>a {
		display: inline-block;
		width: 100%;
		color: #000000 !important;
		margin-bottom: 10px;
	}
	.header-nav-wrapper>li>dl>dt>a {
		font-size: 0.8em;
		color: #848484 !important;
		margin: 10px 0;
		padding-right: 10px;
	}
	.oneLine {
		/* 限制一行，超出隐藏，调用需指定宽度 */
		overflow: hidden;
		word-break: break-all;
		/* break-all(允许在单词内换行。) */
		text-overflow: ellipsis;
		/* 超出部分省略号 */
		display: -webkit-box;
		/** 对象作为伸缩盒子模型显示 **/
		-webkit-box-orient: vertical;
		/** 设置或检索伸缩盒对象的子元素的排列方式 **/
		-webkit-line-clamp: 1;
		/** 显示的行数 **/
	}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue